import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '@core';
import { SiteConfigureModule } from 'src/app/view/site-configure/site-configure.module';
import { SiteHomeModule } from 'src/app/view/site-home/site-home.module';
import { SiteEventsModule } from '../site-events/site-events.module';
import { SiteComponent } from './site.component';

@NgModule({
  declarations: [SiteComponent],
  exports: [SiteComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatRippleModule,
    TranslateModule,
    MatTooltipModule,
    SiteHomeModule,
    SiteConfigureModule,
    SiteEventsModule,
    CoreModule,
  ],
})
export class SiteModule {}
